import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { AMO_URL } from '@shared/helpers/env';

class AmoServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getList(params) {
    return this.http.get('/users', { params: params });
  }

  isAuth(params = {}) {
    return this.pure_http.get('/auth/is-auth', { params: params });
  }

  getSettingsData(params = {}) {
    return this.pure_http.get('/client-configs/widget-configs', { params: params });
  }

  updateSettingsData(params) {
    return this.http.put(`/client-configs/widget-configs`, params);
  }

  getUsersData(params = {}) {
    return this.pure_http.get('/users', { params: params });
  }

  syncUsers(params = {}) {
    return this.pure_http.get('/users/sync', { params: params });
  }
}

export const AmoService = new AmoServiceClass({
  api_version: 1,
  base_url: AMO_URL,
  resource: '/'
});
